import { getHoustonOptimizelySdkOptionsFactory } from "./getHoustonOptimizelySdkOptionsFactory";
import { pulseEventDispatcher } from "./pulseEventDispatcher.browser";

export { pulseEventDispatcher } from "./pulseEventDispatcher.browser";
export { noOpDispatcher } from "./noOpDispatcher";

const getHoustonOptimizelySdkOptions = getHoustonOptimizelySdkOptionsFactory({
  pulseEventDispatcher,
});

export const getSSROptions = () => {
  throw new Error("getSSROptions not implemented in browser environment");
};

export { getHoustonOptimizelySdkOptions };
